import './GranDBanner.css'
import grandLogo from '../../assets/grand/grand-logo-white.png'
import { Flex, Stack } from '@mantine/core'
import { Link } from 'react-router-dom'
import SectionTitle from '../../components/SectionTitle/SectionTitle'
export default function GranDBanner() {
    return <section className='GranDBanner-main-container'>


        <Stack 
        classNames={{root: "GranDBanner--text-wrapper"}}>
            <SectionTitle
                upText='Grandes animales'
            >
                <h2 className="sectionTitle-downText">Especializate en <strong>ganadería, equinos y producción</strong></h2>
            </SectionTitle>
            <h5 className='GranDBanner--subheading'>Capacitaciones para <strong>veterinarios y productores</strong></h5>
            <Flex w='100%' justify='start' mt={16}>
                <Link to="/grand" className="GranDBanner-cta ">
                    Ver todos los programas
                    <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                </Link>
            </Flex>
        </Stack>
        <figure className='GranDBanner--logo-container'>
            <img className='GranDBanner--logoImage' src={grandLogo} alt="GranD Logo" />
        </figure>
    </section>
}